import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import createAxiosInstance from '../../services/axiosConfig';
const api = createAxiosInstance(process.env.REACT_APP_ESTEIRA_BACK + '/rest/propostaEsteiraController');
type Item = { id: number; proposta: string; contrato: string; valor: number };
type Grupo = { chave: string; tipo: string; fundo: number | null; nome: string;
  solicitado: number; saldo: number; faltante: number; propostas: Item[] };
type Plano = { grupos: Grupo[]; comuns: number[]; assinatura: string };
const moeda = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export default function FidcLoteModal({ ids, reprovar, onHide, onProcessed }: {
  ids: number[]; reprovar: boolean; onHide: () => void; onProcessed: (resultado: string) => void;
}) {
  const [plano, setPlano] = useState<Plano | null>(null);
  const [decisoes, setDecisoes] = useState<Record<string, boolean>>({});
  const [justificativa, setJustificativa] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState('');
  const carregar = async () => {
    setOcupado(true); setErro(''); setPlano(null); setDecisoes({});
    try {
      const r = await api.post('/analisarLoteFidc', ids);
      const dados: Plano = r.data;
      if (reprovar && (dados.comuns.length || dados.grupos.some(g => g.tipo !== 'CONFIRMACAO')))
        throw new Error('Para reprovar a confirmação FIDC, selecione apenas propostas dessa atividade.');
      setPlano(dados);
      if (reprovar) setDecisoes(Object.fromEntries(dados.grupos.map(g => [g.chave, false])));
    } catch (e: any) { setErro(typeof e.response?.data === 'string' ? e.response.data : e.message || 'Falha ao analisar lote.'); }
    finally { setOcupado(false); }
  };
  useEffect(() => { carregar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const executar = async () => {
    if (!plano) return;
    setOcupado(true); setErro('');
    try {
      const r = await api.post('/executarLoteFidc', { propostas: ids, assinatura: plano.assinatura, decisoes, justificativa });
      onProcessed(r.data.join('\n'));
    } catch (e: any) {
      setErro(typeof e.response?.data === 'string' ? e.response.data : 'Falha ao processar lote.');
      setPlano(null);
    } finally { setOcupado(false); }
  };
  return <Modal show onHide={() => !ocupado && onHide()} size="xl" centered scrollable backdrop="static">
    <Modal.Header closeButton={!ocupado}><Modal.Title>Processamento por FIDC</Modal.Title></Modal.Header>
    <Modal.Body>
      {erro && <div role="alert" className="alert alert-danger">{erro}</div>}
      {ocupado && <p role="status">Aguarde...</p>}
      {!plano && !ocupado && <Button onClick={carregar}>Atualizar análise</Button>}
      {plano?.grupos.map(g => <section className="card mb-3" key={g.chave}>
        <div className="card-header"><strong>{g.nome}</strong> — FIDC {g.fundo ?? 'não identificado'}</div>
        <div className="card-body">
          <p>Total solicitado: <strong>{moeda(g.solicitado)}</strong> · Saldo: <strong>{moeda(g.saldo)}</strong> · Valor faltante: <strong>{moeda(g.faltante)}</strong></p>
          {g.tipo === 'SELECAO' && (g.faltante > 0 || !g.fundo)
            ? <div className="alert alert-warning">Todas as propostas abaixo serão pendenciadas na Seleção Automática de FIDC e encaminhadas à Confirmação FIDC. Nenhum pagamento será enviado por este grupo.</div>
            : g.tipo === 'SELECAO' && <p>Saldo suficiente para este grupo. As propostas seguirão o fluxo de aprovação.</p>}
          <table className="table table-sm"><thead><tr><th>Proposta</th><th>Contrato</th><th>Valor principal</th></tr></thead>
            <tbody>{g.propostas.map(p => <tr key={p.id}><td>{p.proposta || p.id}</td><td>{p.contrato || '—'}</td><td>{moeda(p.valor)}</td></tr>)}</tbody></table>
          {g.tipo === 'CONFIRMACAO' && <>
            <p><strong>O sistema vai selecionar outro FIDC elegível para distribuir o valor faltante. Tem certeza que deseja continuar?</strong></p>
            <p>Serão consideradas as propostas acima, na ordem exibida, sem dividir um contrato entre fundos.</p>
            <Button variant={decisoes[g.chave] === true ? 'success' : 'outline-success'} disabled={ocupado || reprovar} className="me-2" onClick={() => setDecisoes({ ...decisoes, [g.chave]: true })}>SIM</Button>
            <Button variant={decisoes[g.chave] === false ? 'danger' : 'outline-danger'} disabled={ocupado} onClick={() => setDecisoes({ ...decisoes, [g.chave]: false })}>NÃO</Button>
            {decisoes[g.chave] === false && <p className="mt-2">As propostas deste fundo permanecerão pendentes, sem consumo do limite.</p>}
          </>}
        </div>
      </section>)}
      {!!plano?.comuns.length && <p>{plano.comuns.length} proposta(s) seguirá(ão) o processamento comum, sem próxima atividade de seleção FIDC.</p>}
      {plano && <><label htmlFor="justificativaLoteFidc">Justificativa</label><textarea id="justificativaLoteFidc" className="form-control"
        maxLength={1000} disabled={ocupado} value={justificativa} onChange={e => setJustificativa(e.target.value)} /></>}
    </Modal.Body>
    <Modal.Footer><Button variant="secondary" disabled={ocupado} onClick={onHide}>Voltar</Button>
      <Button disabled={ocupado || !plano || !justificativa.trim() || plano.grupos.some(g => g.tipo === 'CONFIRMACAO' && decisoes[g.chave] === undefined)}
        onClick={executar}>Processar decisões</Button></Modal.Footer>
  </Modal>;
}
